const Loader = () => {

  return (

    <>

    <div className="loading_dots">
          

        <div className="circle-line">   
                <div className="circle-red">&nbsp;</div>
                <div className="circle-blue">&nbsp;</div>
                <div className="circle-green">&nbsp;</div>
                <div className="circle-yellow">&nbsp;</div>
        </div>

    </div>


    </>


  )
}

export default Loader